export const MONTH_PICKER_MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
export const MONTH_PICKER_DATE_PATTERN =
  /^(\d{4})-(\d{1,2})(?:-\d{1,2}(?:T.*)?)?$/;
export const MONTH_PICKER_NAMED_PATTERN = /^([a-z]+)\.?[\s,/-]+(\d{4})$/i;
export const MONTH_PICKER_YEAR_PATTERN = /^\d{4}$/;
export const MONTH_PICKER_MIN_YEAR = 1;
export const MONTH_PICKER_MAX_YEAR = 9999;
export const MONTH_PICKER_YEARS_PER_PAGE = 12;
export const MONTH_PICKER_OPTION_CLASS_NAME =
  "h-8 rounded-md text-xs font-medium transition-colors hover:bg-[#F2F4F7] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0D41E1] disabled:pointer-events-none disabled:opacity-30";
export const MONTH_PICKER_SELECTED_CLASS_NAME =
  "bg-[#0D41E1] text-white hover:bg-[#0D41E1]";
